import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, OnInit } from '@angular/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { FlatNode } from '../../../interfaces/flat-node';
import { NodeResult } from '../../../models/net/result/node-result';
import { AppService } from '../../../services/app.service';
import { NodesService } from '../../../services/nodes/nodes.service';
import { UserSession } from '../../../interfaces/user-session';
import { NodeSearchRequest } from '../../../models/net/request/node-search-request';
import { UtilityFunctions } from '../../../utilities/utility-functions';

@Component({
    selector: 'app-shortcuts',
    templateUrl: './shortcuts.component.html',
    styleUrls: ['./shortcuts.component.css', '../../../app.component.css']
})

export class ShortcutsComponent implements OnInit {

    private _nodeTransformer = (node: NodeResult, level: number): FlatNode => {

        let result: FlatNode = {
            id: node.NodeId,
            expandable: !!node.Nodes && node.Nodes.length > 0,
            name: node.DisplayText,
            shortName: node.ShortDisplayText ?? "",
            venueRootSubdomain: node.VenueRootSubdomain ?? "",
            route: node.Route,
            level: level,
            color: "black",
            maticon: node.IconName,
            iconOverrideImagePath: node.IconOverrideImagePath
        };

        return result;
    };

    public treeControl = new FlatTreeControl<FlatNode>(
        node => node.level,
        node => node.expandable
    );

    public treeFlattener = new MatTreeFlattener(
        this._nodeTransformer,
        node => node.level,
        node => node.expandable,
        node => node.Nodes
    );

    public dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);
    public hasChild = (_: number, node: FlatNode) => node.expandable;

    public appNodes: any = null;

    public isEditor: boolean = false;

    public constructor(public appService: AppService, private nodeService: NodesService) { }

    public ngOnInit() {

        const subdomain: string = UtilityFunctions.getSubdomain();
        let startAfterNodeId: number | null = null;

        this.appService.loggedIn.subscribe((session: any) => {

            if (subdomain == "mendls") {

                startAfterNodeId = 48;

            } else if (subdomain == "admin") {

                startAfterNodeId = 1;

            } else if (subdomain == "" || subdomain == "www") {

                startAfterNodeId = 1;
            }

            this.loadNodes(false, subdomain, startAfterNodeId);
        });

        this.appService.loggedOut.subscribe((result: any) => {

            this.loadNodes(true, subdomain, startAfterNodeId);
        });

        this.nodeService.nodesUpdated.subscribe(() => {

            this.loadNodes(false, subdomain, startAfterNodeId);
        });

        if (!this.appService.isLoggedIn) {

            if (subdomain == "mendls") {

                startAfterNodeId = 48;

            } else if (subdomain == "admin") {

                startAfterNodeId = 1;

            } else if (subdomain == "" || subdomain == "www") {

                startAfterNodeId = 1;
            }

            this.loadNodes(true, subdomain, startAfterNodeId);
        }
    }

    private loadNodes = (isPublicOnly: boolean, subdomain: string, startAfterNodeId: number | null) => {

        let nodes: NodeResult[] = [];

        if (isPublicOnly) {

            const subdomain: string = UtilityFunctions.getSubdomain();

            this.nodeService.getPublicNodes(subdomain).subscribe((nodes: NodeResult[] | null) => {

                if (nodes) {

                    this.nodeService.currentNodes = nodes;

                    if (startAfterNodeId) {

                        this.dataSource.data = UtilityFunctions.extractChildNodes(nodes, startAfterNodeId);

                    } else {

                        this.dataSource.data = nodes;
                    }
                }
            });

        } else {

            const userSessionString: string | null = this.appService.getUserSession();

            if (userSessionString) {

                const userSession: UserSession = JSON.parse(userSessionString);
                let request: NodeSearchRequest = new NodeSearchRequest();

                request.UserId = userSession.userId;
                request.Subdomain = subdomain;

                this.nodeService.search(request).subscribe((nodes: NodeResult[] | null) => {

                    if (nodes != null && nodes) {

                        this.nodeService.currentNodes = nodes;

                        if (startAfterNodeId) {

                            this.dataSource.data = UtilityFunctions.extractChildNodes(nodes, startAfterNodeId);

                        } else {

                            this.dataSource.data = nodes;
                        }
                    }
                });
            }
        }
    }
}
